import { Injectable, inject } from '@angular/core';
import {NetworkService} from '../../../../../../projects/common/src/lib/services/network.service';
import {BaseApiService} from '../base-api.service';
import {FirebaseApi} from '../../firebase-api.service';

export interface TokenResult {
  expired: boolean;
  timeLeft: number;
}

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseApiService {

  constructor() {

    super();
  }

  getOriginData() {
    return this.get<any>('/origin');
  }

  createCustomToken(duration?: number): Promise<any> {
    return this.post('/tokens/new', {duration});
  }

  validateCustomToken(customToken: string): Promise<TokenResult> {
    return this.post(`/tokens/${customToken}/validate`, null);
  }

  deleteMyAccount(reason: string) {
    return this.delete(`/account`, {reason: reason});
  }
}
